<template>
    <actions-menu v-model:dialogEdit="editRequestDialog" :ShowDialogConsult="true"
        dialogConsult="DeliveryClientOrdersDetails" v-model:dialogConsult="editRequestDialog" :Id="Id"
        :dialogConsultUrl="idOrder" v-model:dialogDelete="dialog" :ShowDialogStatus="false" :ShowDialogDelete="false"
        :ShowDialogEdit="isDelivery()" />
    <v-dialog v-model="editRequestDialog">
        <v-card elevation="0" width="500px" class="py-2 px-2" style="border-radius: 12px">
            <v-card-title class="justify-content-center">
                <span class="title"> {{ $t("Delivery.DeliveryPerson.Assign") }} </span>
            </v-card-title>
            <v-card-title class="text-left">
                {{ $t("Delivery.DeliveryPerson.Name") }}<span class="red">*</span>
            </v-card-title>
            <v-autocomplete id="DeliveryPerson" name="DeliveryPersonName" variant="outlined" v-model="DeliveryPersonId"
                persistent-placeholder
                :placeholder="$t('placeholder.select', { itm: $t('Delivery.DeliveryPerson.Name'), })" :items="items"
                item-title="deliveryPersonName" item-value="deliveryPersonId" hide-details :readonly="!isEditMode"
                :class="!isEditMode ? 'readonly-field' : ''">
                <template v-slot:item="{ props, item }">
                    <v-list-item v-bind="props" variant="text">
                        {{ item.DeliveryPersonName }}
                    </v-list-item>
                </template>
            </v-autocomplete>
            <span class="warningHint" id="WarningMsgReference">
                {{ msg.DeliveryPersonName }}
            </span>

            <card-actions :yes="setOrderToPerson" v-model:no="editRequestDialog" :loader="loader" :yesDisable="loader"
                width="200px" :yesTitle="$t('actions.save')" />
        </v-card>
    </v-dialog>
</template>

<script>
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import cardActions from "@/genericComponent/cardActions.vue";
import { GetAllDeliveryPersonsForDeliveryCompany, isDelivery, setDeliveryToPerson } from "@/api/index";
export default {
    components: { actionsMenu, cardActions },
    props: ["idOrder", "Id", "getClientOrdersByOrderId", "deliveryPersonId", "deliveryPersonName"],

    mounted() {
        this.GetDeliveryPersons();
    },
    data() {
        return {
            items: [],
            isEditMode: true,
            msg: [],
            DeliveryPersonId: this.deliveryPersonId,
            editRequestDialog: false,
            loader: false,
        };
    },
    methods: {
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        ActiveDeletedSnackBar() {
            this.getParent('MainLayout').ActiveDeletedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        setOrderToPerson() {
            this.loader = true
            if (this.DeliveryPersonId == null) {
                this.msg["DeliveryPersonName"] = this.$t('Delivery.DeliveryPerson.NameRequired');
                return;
            } else {
                this.msg["DeliveryPersonName"] = "";
            }
            setDeliveryToPerson(this.DeliveryPersonId, this.idOrder).then(() => {
                this.editRequestDialog = false;
                this.getClientOrdersByOrderId()
                this.ActiveSavedSnackBar()
            }).catch(() => {
                this.ActiveWarningSnackBar()
            });
            this.loader = false
        },
        GetDeliveryPersons() {
            if (isDelivery()) {
                GetAllDeliveryPersonsForDeliveryCompany().then((response) => {
                    this.items = response.data;
                }).catch((error) => {
                    console.error(error);
                });
            }
        },
        isDelivery() {
            return isDelivery()
        }
    },
};
</script>
<style scoped>
h1 {
    font-family: inter;
    font-size: 18px;
    line-height: 29px;
    font-weight: 600;
    color: #0d0849;
    text-align: center;
}

.v-card-text {
    font-family: inter;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    color: #768da9;
}

.rounded-table {
    border-radius: 10px;
}

.custom-divider {
    border-top: 1px solid;
    border-color: currentColor;
}

.border-right {
    border: 1px solid #ddd;
    text-align: center;
    border-style: dotted;
    padding: 2px 4px;
}

.totals {
    margin-top: 20px;
    /* font-weight: bold; */
}

.align-right {
    padding-right: 85px;
    text-align: right;
    position: relative;
}

.totals p {
    margin: 5px 0;
}

.align-devise {
    float: right;
    margin-left: -16px;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #5b6d8e;
}

.textConsumptionThreshold {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 29px;
    display: flex;
    align-items: center;
    color: #080c3e;
}

.customWarningHint {
    color: #f25c5c;
    padding: 12px 0px 12px 12px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 0px;
    display: block;
    text-align: left;
    text-wrap: nowrap;
}
</style>
